var Theme = Theme || {};

Theme.CallsForSubmissions = (function ($) {
    const WidgetSelector = '.js-calls-for-submissions';
    const ButtonSelector = '.js-calls-for-submissions-view-more';
    const HiddenItemSelector = '.calls-for-submissions__item.hide';
    const ExpandedClass = 'calls-for-submissions--expanded';

    return {
        init: _init
    };

    function _init() {
        $(WidgetSelector).each(function () {
            const $widget = $(this);
            if ($widget.find(ButtonSelector).length) {
                $widget.on('click', ButtonSelector, _expandWidget);
            }
        });
    }

    function _expandWidget(e) {
        const $widget = $(e.currentTarget).closest(WidgetSelector);
        // Lock the widget at its current (collapsed) height before revealing
        // hidden items so the items overflow scrolls instead of pushing the
        // widget taller. CSS can't read an element's own measured height,
        // so we capture it in JS and write it as an inline style.
        $widget[0].style.height = $widget.height() + 'px';
        $widget.addClass(ExpandedClass);
        $widget.find(HiddenItemSelector).removeClass('hide').removeAttr('aria-hidden');
        $widget.find(ButtonSelector).addClass('hide');
    }

})(jQuery);
